import React, { useState, useEffect, memo } from 'react';
import { MDBDataTable } from 'mdbreact';
import { mdbdatatable_config as config } from '../Const';

interface Props {
  datas: object[];
  columns: object[];
  params: {
    entries?: number;
    displayEntries?: boolean;
    scrollx?: boolean;
    entriesOptions?: number[];
  };
  is_init?: boolean;
}

const MaintenanceTable: React.FC<Props> = ({ datas, columns, params, is_init = false }) => {
  const [info_label, setInfoLabel] = useState(config.info_label.zero_rows);

  useEffect(() => {
    // infoLabelのプロパティを変更する
    if (datas.length > 0) {
      setInfoLabel(config.info_label.init);
    } else {
      setInfoLabel(config.info_label.zero_rows);
    }
  }, [datas]);

  return (
    <div id="mdb-datatable">
      <MDBDataTable
        hover
        entries={params.entries ?? 20}
        data={{
          columns: columns,
          rows: datas,
        }}
        searching={false}
        sortable={false}
        displayEntries={params.displayEntries ?? false}
        infoLabel={info_label}
        entriesLabel=""
        entriesOptions={params.entriesOptions ?? undefined}
        noBottomColumns
        paginationLabel={['前', '次']}
        noRecordsFoundLabel={is_init ? '' : '該当する情報が見つかりません'}
        key="mdbdatatable"
        scrollX={params.scrollx ?? false}
      />
    </div>
  );
};

export default memo(MaintenanceTable);
